import React, { createContext, useContext, useState, useEffect } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setAdmin(data);
    } catch {
      setAdmin(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  const login = async (email, password, turnstileToken) => {
    try {
      const { data } = await api.post("/auth/login", { email, password, turnstile_token: turnstileToken || undefined });
      return { success: true, otpRequired: true, preAuthToken: data.pre_auth_token, email: data.email };
    } catch (e) {
      return { success: false, error: formatApiError(e.response?.data?.detail) };
    }
  };

  const verifyOtp = async (preAuthToken, otp) => {
    try {
      const { data } = await api.post("/auth/verify-otp", { pre_auth_token: preAuthToken, otp });
      setAdmin(data);
      return { success: true };
    } catch (e) {
      return { success: false, error: formatApiError(e.response?.data?.detail) };
    }
  };

  const resendOtp = async (preAuthToken) => {
    try {
      await api.post("/auth/resend-otp", { pre_auth_token: preAuthToken });
      return { success: true };
    } catch (e) {
      return { success: false, error: formatApiError(e.response?.data?.detail) };
    }
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, verifyOtp, resendOtp, logout, refreshAdmin: checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
